import { Dispatch } from "redux";

import { ACTIONS } from "./types";
import { Request } from "types/requests";
import { defaultRequestStatus } from "constants/caseMangement";
import { CreateRequestApiRequestsCreateRequestPostRequest } from "api-client/apis/RequestsApi";
import store from "config/store";
import { getAuthConfiguration } from "utils/getAuthConfiguration";
import { RequestsApi } from "api-client/apis/RequestsApi";

export const getRequestComments = (requestId: string, page: number) => async (dispatch: Dispatch) => {
    const apiBaseUrl = store.getState().appConfiguration.apiBaseUrl;
    const requestsApi = new RequestsApi(getAuthConfiguration(apiBaseUrl));
    try {
        dispatch({
            type: ACTIONS.GET_REQUEST_COMMENTS_REQUEST
        });
        const res = await requestsApi.getCommentsByRequestApiRequestsRequestCommentsGet({requestId: requestId, page: page})
        dispatch({
            type: ACTIONS.GET_REQUEST_COMMENTS_SUCCESS,
            payload: res
        })
    } catch (e) {
        dispatch({
            type: ACTIONS.GET_REQUEST_COMMENTS_FAILURE
        })
        throw e;
    }
}


export const getRequests = (page: number) => async (dispatch: Dispatch) => {
    const apiBaseUrl = store.getState().appConfiguration.apiBaseUrl;
    const requestsApi = new RequestsApi(getAuthConfiguration(apiBaseUrl));
    try {
        dispatch({
            type: ACTIONS.GET_REQUESTS_REQUEST,
        });
        const res = await requestsApi.getRequestApiRequestsUserRequestsGet({page: page});
        dispatch({
            type: ACTIONS.GET_REQUESTS_SUCCESS,
            payload: res,
        });
    } catch (e) {
        dispatch({
            type: ACTIONS.GET_REQUESTS_FAILURE,
        });
        throw e;
    }
};

export const getAvailableIssueTypes = () => async (dispatch: Dispatch) => {
    const apiBaseUrl = store.getState().appConfiguration.apiBaseUrl;
    const requestsApi = new RequestsApi(getAuthConfiguration(apiBaseUrl));
    try {
        dispatch({
            type: ACTIONS.GET_AVAILABLE_ISSUE_TYPES_REQUEST,
        });
        const res = await requestsApi.getAvailableRequestTypesApiRequestsAvailableRequestTypesGet();
        dispatch({
            type: ACTIONS.GET_AVAILABLE_ISSUE_TYPES_SUCCESS,
            payload: res,
        });
    } catch (e) {
        dispatch({
            type: ACTIONS.GET_AVAILABLE_ISSUE_TYPES_FAILURE,
        });
        throw e;
    }
};

export const createRequest = (
    data: CreateRequestApiRequestsCreateRequestPostRequest,
    issueType: string,
) => async (dispatch: Dispatch) => {
    const apiBaseUrl = store.getState().appConfiguration.apiBaseUrl;
    const requestsApi = new RequestsApi(getAuthConfiguration(apiBaseUrl));
    try {
        dispatch({
            type: ACTIONS.CREATE_REQUEST_REQUEST,
        });

        const res = await requestsApi.createRequestApiRequestsCreateRequestPost(data);
        const request: Request = {
            issueId: res.issueId,
            timestamp: res.timestamp,
            requestId: res.requestId,
            summary: data.summary,
            status: defaultRequestStatus,
            issueType: issueType,
            description: data.description,
        };
        dispatch({
            type: ACTIONS.CREATE_REQUEST_SUCCESS,
            payload: request,
        });
    } catch (e) {
        dispatch({
            type: ACTIONS.CREATE_REQUEST_FAILURE,
        });
        throw e;
    }
};
